const path = 'UserProfileModule';
const apiPath = '/user/setting';

const UserProfileActions = {
  // action types
  GET_DATA : `${path}/getBank`,
  RESET : `${path}/reset`,
  SUBSCRIBE : `${path}/subscribe`,
  GET_LIST_DATA : `${path}/getListData`,
  GET_PROFILE : `${path}/getProfile`,
  UPDATE_PROFILE : `${path}/updateProfile`,
  CHANGE_PASSWORD : `${path}/changePassword`,
}

// const BankMutations = {
//   // mutation types
//   SET_ERROR : `${path}/setError`,
//   RESET_DATA : `${path}/resetData`,
//   SET_DATA : `${path}/setBank`,
//   SET_LIST_DATA : `${path}/setListData`,
// }

const UserProfileAPIsConstants = {
  // api's
  API_PATH : `${apiPath}`,
}

export { UserProfileActions,UserProfileAPIsConstants };
